module.exports = __webpack_public_path__ + "static/media/black-grey-surrealism-girl-and-skull-tattoo.38a2aa84.png";